import React from 'react';
import GhostPatrol from './GhostPatrol';
import Tooltip from './Tooltip';

/**
 * The one "waiting" state (owner, 07.10.2026): the ghost swinging left and
 * right, a title, one meta line (what is running · how long) and a Cancel /
 * Stop pill. The API Client's "Awaiting response" and the DB Manager's running
 * query both render this, so they cannot drift apart again.
 *
 * The cancel control is a div with role=button on purpose: the global button
 * reset (`border: medium none !important`) would erase its outline border
 * (see .req-loading-cancel in index.css).
 */
export default function WaitingGhost({ title, meta, onCancel, cancelLabel = 'Cancel', cancelHint, className = '', ...rest }) {
  const cancel = onCancel ? (
    <div
      role="button"
      tabIndex={0}
      aria-label={cancelLabel}
      className="req-loading-cancel waiting-ghost-cancel"
      onClick={onCancel}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onCancel();
        }
      }}
    >
      {cancelLabel}
    </div>
  ) : null;

  return (
    <div className={`waiting-ghost${className ? ` ${className}` : ''}`} role="status" {...rest}>
      <div className="req-loader-ghost">
        <GhostPatrol size={36} style={{ marginBottom: 14 }} />
      </div>
      <div className="waiting-ghost-text">
        {title && <div className="req-loading-title">{title}</div>}
        {meta && <div className="req-loading-meta">{meta}</div>}
      </div>
      {cancel && cancelHint ? (
        <Tooltip content={cancelHint} side="bottom">
          {cancel}
        </Tooltip>
      ) : (
        cancel
      )}
    </div>
  );
}
